// extracted by css-extract-rspack-plugin
export default {"codeInput":"codeInput-nmKkTt"};